import { render, staticRenderFns } from "./Advertising.vue?vue&type=template&id=d562c888&scoped=true"
import script from "./Advertising.vue?vue&type=script&lang=js"
export * from "./Advertising.vue?vue&type=script&lang=js"
import style0 from "./Advertising.vue?vue&type=style&index=0&id=d562c888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d562c888",
  null
  
)

export default component.exports